import React, { useEffect, useRef } from 'react'
import ContentGroupManager from '../account/components/contentGroupManager'

const ContentGroups = props => {
  const ref = useRef()
  const htmlEl = document.documentElement
  useEffect(() => {
    if (ref.current) {
      htmlEl.style.fontSize = 'initial'
    }
    htmlEl.style.fontSize = 'initial'
    return () => {
      // reset html font-size on unmount
      htmlEl.style.fontSize = '10px'
    }
  }, [ref])
  return <ContentGroupManager />
}

const ContentGroupsRoute = (api, socket, opts, match) => {
  return () => {
    return <ContentGroups />
  }
}

export default ContentGroupsRoute
